/* Copyright (c) 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Spinner, Text, theme } from "@nordcloud/gnui";

export function InlineLoading() {
  return (
    <LoadingWrapper>
      <Spinner size="sm" />
      <Text weight="regular" tag="div" ml={theme.spacing.spacing04}>
        Loading...
      </Text>
    </LoadingWrapper>
  );
}

const LoadingWrapper = styled.div`
  align-items: center;
  display: flex;
`;
